module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_600.c648508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_lets-get_600.png
// module id = ZDaI
// module chunks = 0